<template>
    <b-container fluid class="text-light">
      <b-row style="padding-top:5px">
        <b-col cols="8">
          <img v-bind:src="'https://heavens-above.com/conchart.ashx?sz=800&con=' + abbreviation"  style="border:1px solid #888">
        </b-col>
        <b-col cols="4">
          <b-card no-body class="text-light text-center" header-tag="header">
            <template v-slot:header>{{strings["constellation"] + ': ' + strings["con." + abbreviation]}}</template>
            <b-table-simple class="table-dark table-sm text-light" outlined bordered>
              <b-tbody class="text-left">
                <b-tr>
                  <b-td>{{strings["name"]}}:</b-td>
                  <b-td>{{constellation ? strings["con." + abbreviation] : null}}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{strings["abbreviation"]}}:</b-td>
                  <b-td>{{ (constellation ? abbreviation : null)}}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{strings["genitive"]}}:</b-td>
                  <b-td>{{genitive}}</b-td>
                </b-tr>
                <b-tr>
                  <b-td>{{strings["area"]}}:</b-td>
                  <b-td>{{constellation ? constellation.area : null}}</b-td>
                </b-tr>
                <b-tr v-if="showMythology">
                  <b-td colspan="2">
                    <b-button block v-b-toggle.collapse-myth size="sm">Show Mythology</b-button>
                      <b-collapse id="collapse-myth" class="mt-2">
                        <b-card>
                          <p class="card-text">{{constellation ? constellation.mythology : null}}</p>
                        </b-card>
                      </b-collapse>
                  </b-td>
                </b-tr>
              </b-tbody>
            </b-table-simple>
          </b-card>
          <b-list-group flush class="text-light text-left">
            <b-list-group-item v-for="st in stars" v-bind:key="st.hip">{{designation(st)}} {{numeral(st.mag).format("0,0.00")}}</b-list-group-item>  
          </b-list-group>
        </b-col>
      </b-row>
    </b-container>
</template>

<script>
import Vue from "vue";
import Vuex from "vuex";
import VueRouter from "vue-router";
import { mapState } from "vuex";
import axios from "axios";
import numeral from "numeral";

Vue.use(Vuex);
Vue.use(VueRouter);

export default {
  name: "ConstellationPage",
  components: {
  },

  computed: {
    // constellation() {
    //   return this.$store.getters.getConstellation(this.abbreviation);
    // },
    genitive() {
      return (this.constellation ? this.constellation.genitive : null);
    },
    abbreviation() {
      return this.$route.params.con;
    },
    ...mapState([
    "utc",
    "location",
    "culture",
    "strings",
    "staticData",
  ])
  },
  watch: {
    // $route() {
    //   // react to route changes...
    //   if (!this.constellation)
    //     this.$store.dispatch("loadConstellation", this.abbreviation);
    // }
  },
  mounted() {
    document.title = "Constellation";
    // see if constellation is available
    if (!this.constellation) {
          axios
        .post("http://localhost:65228/graphql", {
          query: "query constellation($id: String) {constellations(id: $id) {abbreviation genitive sizeRank latinName area mythology brightStars {name bayer bayerNum flamsteed ra2000 de2000 mag parallax pmRA pmDE spType hr hd sao hip }}}",
          variables: {id: this.abbreviation},
          operationName: "constellation"
        })
        .then(response => {
          console.log(response.data);
          // cache to local storage
          this.constellation = response.data.data.constellations[0];
          this.stars = this.constellation.brightStars;
          //localStorage.setItem(cacheKey, JSON.stringify(constell));
          //commit("setConstellation", constell);
        })
        .catch(error => {
          console.log(error);
        });
    
    }
  
    
    //this.constellation = this.staticData.cons[this.selected];
    this.showMythology = (this.culture == 'en');
    this.stars = [{}];
  },
  methods: {
    layout: function() {
    },
    numeral: numeral,
    designation: function(star) {
      let desig = star.bayer;
      if (!desig)
        desig = star.flamsteed;
      else if (star.bayerNum)
        desig = desig + star.bayerNum;

      if (star.name)
        desig = desig + ' ' + star.name;
      
      return desig;
    }
  },
  data() {
    return {
      showMythology: false, 
      constellation: null
    };
  }
};
</script>

<style>
 
</style>